import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from '../context/UserContext';
import TopBar from './TopBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import leftMenuStyles from './LeftMenu.module.css';

// Internal reusable component for mobile-friendly login prompt
const MobileLoginPrompt = () => {
  const navigate = useNavigate();
  
  return (
    <div className={leftMenuStyles['login-prompt-container']} style={{ display: 'flex' }}>
      <div className={leftMenuStyles['login-prompt']}>
        <div className={leftMenuStyles['login-icon']}>
          <FontAwesomeIcon icon={faSignInAlt} />
        </div>
        <h2>Please Sign In</h2>
        <p>You need to be logged in to view this content.</p>
        <button 
          className={leftMenuStyles['login-button']}
          onClick={() => navigate('/login')}
        >
          Log In / Sign Up
        </button>
      </div>
    </div>
  );
};

// This component wraps the main content of a page and shows 
// the login prompt if the user is not logged in
const AuthCheckWrapper = ({ children }) => {
  const { userData } = useContext(UserContext);
  const [isMobile, setIsMobile] = useState(false);

  // Function to check if it's mobile view
  const checkIfMobile = () => {
    const mobileWidth = 768; // Based on the CSS @media rules
    setIsMobile(window.innerWidth <= mobileWidth);
  };

  useEffect(() => {
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  if (!userData) {
    return (
      <div style={{ width: '90%', height: '100vh', position: 'relative' }}>
        {/* Always include TopBar for consistent UX */}
        <TopBar />
        
        {/* Use our custom MobileLoginPrompt component that forces display */}
        <MobileLoginPrompt />
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthCheckWrapper;